<template>
    <h3>Page Not Found 404</h3>
</template>

<script>
export default {
    name: 'ErrorView'
}
</script>